// services/SoftphoneContactsService.js
import { apiUc } from '../../../../../http';

class SoftphoneContactsService {
  async getSoftphoneContactsList() {
    const userLogin = localStorage.getItem('login');
    return apiUc.get(`/api/softphone-contacts`, {
      headers: {
        'usr-login': userLogin
      }
    });
  }

  async createSoftphoneContact(contact) {
    const userLogin = localStorage.getItem('login');
    return apiUc.post(`/api/softphone-contacts`, contact, {
      headers: {
        'usr-login': userLogin
      }
    });
  }

  async updateSoftphoneContact(contact, contactId) {
    const userLogin = localStorage.getItem('login');
    return apiUc.put(`/api/softphone-contacts/${contactId}`, contact, {
      headers: {
        'usr-login': userLogin
      }
    });
  }

  async deleteSoftphoneContact(contactId) {
    const userLogin = localStorage.getItem('login');
    return apiUc.delete(`/api/softphone-contacts/${contactId}`, {
      headers: {
        'usr-login': userLogin
      }
    });
  }

  async reorderContactList(contacts) {
    const userLogin = localStorage.getItem('login');
    return apiUc.patch(
      `/api/softphone-contacts/reorder`,
      { contacts },
      {
        headers: {
          'usr-login': userLogin
        }
      }
    );
  }
}

export default new SoftphoneContactsService();
